export var SdkOptions;
(function (SdkOptions) {
    SdkOptions["ApiKey"] = "apiKey";
    SdkOptions["Countries"] = "countries";
    SdkOptions["Amount"] = "amount";
    SdkOptions["FlowId"] = "flowId";
    SdkOptions["IntentId"] = "intentId";
    SdkOptions["CurrencyCode"] = "currencyCode";
    SdkOptions["OrderId"] = "orderId";
    SdkOptions["CustomerId"] = "customerId";
    SdkOptions["HideBillingAddress"] = "hideBillingAddress";
    SdkOptions["Theme"] = "theme";
    SdkOptions["Language"] = "language";
    SdkOptions["AllowSaveCard"] = "allowSaveCard";
    SdkOptions["IsSavedCardCvcRequired"] = "isSavedCardCvcRequired";
    SdkOptions["AlternativePaymentMethods"] = "alternativePaymentMethods";
    SdkOptions["PayButton"] = "payButton";
    SdkOptions["SupportedCardBrands"] = "supportedCardBrands";
    SdkOptions["Fraud"] = "fraud";
})(SdkOptions || (SdkOptions = {}));
//# sourceMappingURL=checkout-sdk-base-options.js.map